export default __webpack_public_path__ + "static/media/tapngo.956cf667.svg";